import {
    client,
    getTemplate,
    checkSearchShouldStart,
    toTimestamp,
    getQueryParameterValue,
    createIsbnsParameter,
    prettify
} from "./utilities.js";

/**
 * This class is responsible for running the Instant Search templates
 */
class InstantSearch {
    constructor(searchWrapperContainer) {
        this.searchWrapperContainer = searchWrapperContainer;
        this.q = getQueryParameterValue('q');
        this.contributorParameterValue = getQueryParameterValue('contributor');
        this.titleParameterValue = getQueryParameterValue('title');
    }

    searchFunction(helper) {
        if( checkSearchShouldStart(helper) === false ) {
            this.searchWrapperContainer.style.display = 'none';
            return
        }

        helper.search();
        this.searchWrapperContainer.style.display = 'block';

    }

    /**
     * @returns {*}
     */
    async run() {

        // Show layout elements once results are returned has finished.
        const bookDetailsDiv = document.getElementById("books-wrapper");
        if( bookDetailsDiv !== null ) {
            bookDetailsDiv.style.display = 'block';
        }

        const productLoaderDiv = document.querySelector(".js-supafolio-loader-container");
        if( productLoaderDiv !== null ) {
            productLoaderDiv.style.display = 'none';
        }

        /*
        Set Parameters pulled from Advanced Search on load
         */
        let isbnsListParameterValue = getQueryParameterValue('isbns'),
            categoryParameterValue = getQueryParameterValue('category'),
            imprintParameterValue = getQueryParameterValue('imprint'),
            publisherParameterValue = getQueryParameterValue('publisher'),
            formatParameterValue = getQueryParameterValue('format'),
            fromDateParameterValue = getQueryParameterValue('from_date'),
            toDateParameterValue = getQueryParameterValue('to_date'),
            fromDateTimestamp = '',
            toDateTimestamp = '',
            restrictSearchableAttributes = [],
            filters = [];

        if( isbnsListParameterValue ) {
            filters.push(createIsbnsParameter(isbnsListParameterValue));
        }
        if( this.contributorParameterValue ) {
            restrictSearchableAttributes.push('contributorByLine');
            filters.push(`contributorByLine:"${prettify(this.contributorParameterValue)}"`)
        }
        if( categoryParameterValue ) {
            let categoryParameterValueArray = categoryParameterValue.split(" > ");
            if( typeof categoryParameterValueArray[2] !== 'undefined' ) {
                filters.push(`hierarchicalCategories.lvl2:"${categoryParameterValue}"`)
            } else if( typeof categoryParameterValueArray[1] !== 'undefined' ) {
                filters.push(`hierarchicalCategories.lvl1:"${categoryParameterValue}"`)
            } else if( typeof categoryParameterValueArray[0] !== 'undefined' ) {
                filters.push(`hierarchicalCategories.lvl0:"${categoryParameterValue}"`)
            }
        }
        if( imprintParameterValue ) {
            filters.push(`imprint:"${imprintParameterValue}"`)
        }
        if( publisherParameterValue ) {
            filters.push(`publisher:"${publisherParameterValue}"`)
        }
        if( formatParameterValue ) {
            filters.push(`format:"${formatParameterValue}"`)
        }
        if( this.titleParameterValue || (this.q && this.contributorParameterValue) ) {
            restrictSearchableAttributes.push('title');
        }

        //Set From date and to date
        if( fromDateParameterValue ) {
            fromDateTimestamp = toTimestamp(new Date(fromDateParameterValue.replace('-', '/')));
        }

        if( toDateParameterValue ) {
            toDateTimestamp = toTimestamp(new Date(toDateParameterValue.replace('-', '/')));
        }

        if( fromDateParameterValue && toDateParameterValue ) {
            filters.push(`publicationDate:${fromDateTimestamp} TO ${toDateTimestamp}`);
        } else if( fromDateParameterValue ) {
            filters.push(`publicationDate >= ${fromDateTimestamp}`);
        } else if( toDateParameterValue ) {
            filters.push(`publicationDate <= ${toDateTimestamp}`);
        }

        filters = filters.join(' AND ');

        const bookSearch = client.search({
            source: "products",
            urlSync: {
                mapping: {
                    p: 'spage'
                }
            },
            searchParameters: {
                hitsPerPage: 10,
                filters: filters,
            },
            restrictSearchableAttributes: restrictSearchableAttributes,
            searchFunction: this.searchFunction.bind(this),
        });

        const perPageOptions = [
            {value: 5, label: "5"},
            {value: 10, label: "10"},
            {value: 20, label: "20"},
            {value: 50, label: "50"}
        ];

        const paginationClasses = {
            'link': 'supapress-page',
            'previous': 'js-supapress-previous',
            'active': 'supapress-current-page',
            'next': 'js-supapress-next',
            'disabled': 'disabled'
        };

        const filtersClasses = {
            header: 'left-nav--top-link',
            wrapper: 'filter-block',
            body: 'left-nav--second-level',
            list: 'filter-item__list',
            item: 'filter-option',
        };

        bookSearch.addWidget(
            // bookSearch.widgets.hierarchicalMenuFilter({
            //     container: ".search-results .categories",
            //     operator: 'or',
            //     limit: 30,
            //     autoHide: false,
            //     collapsible: {
            //         collapsed: true
            //     },
            //     resultHandler(item) {
            //         item.name = item.name.toLowerCase();
            //         return item;
            //     },
            //     templates: {
            //         header: 'Subject',
            //         item: getTemplate('facet')
            //     },
            //     classes: filtersClasses
            // }),
            //Search Box Widget
            bookSearch.widgets.searchBox({
                container: "#search-form",
                placeholder: 'Search by title, author or ISBN',
                clearRefinementsOnSearch: false,
                inputID: 'search-field',
                templates: {
                    searchBox: getTemplate('search-form')
                }
            }),
            //Search Box Widget
            bookSearch.widgets.searchBox({
                container: "#search-form-mobile",
                placeholder: 'Search',
                clearRefinementsOnSearch: false,
                inputID: 'search-field',
                templates: {
                    searchBox: getTemplate('search-form')
                }
            }),

            bookSearch.widgets.clearAll({
                container: "#clear-all-wrapper",
                classes: {
                    button: 'red-btn'
                }
            }),
            //Stats widget
            bookSearch.widgets.stats({
                container: '.search-results .results-data',
                statsHandler(item) {
                    return statsHandler(item);
                },
                templates: {
                    stats: getTemplate('stats')
                }
            }),

            //perPageSelector widget top
            bookSearch.widgets.perPageSelector({
                container: ".pagination-wrapper.top .supapress-per-page-wrapper",
                autoHide: true,
                options: perPageOptions
            }),

            //Pagination widget top
            bookSearch.widgets.pagination({
                container: ".pagination-wrapper.top .js-supapress-pagination-wrapper",
                scrollTo: '.page-title',
                scrollToTransition: true,
                classes: paginationClasses,
                labels: {
                    'previous': 'Previous',
                    'next': 'Next',
                    'last': 'Last'
                }
            }),

            //Pagination widget bottom
            bookSearch.widgets.pagination({
                container: ".pagination-wrapper.bottom .js-supapress-pagination-wrapper",
                scrollTo: '.page-title',
                scrollToTransition: true,
                classes: paginationClasses,
                labels: {
                    'previous': 'Previous',
                    'next': 'Next',
                    'last': 'Last'
                }
            }),

            //perPageSelector widget bottom
            bookSearch.widgets.perPageSelector({
                container: ".pagination-wrapper.bottom .supapress-per-page-wrapper",
                autoHide: true,
                options: perPageOptions
            }),
            bookSearch.widgets.results({
                container: "#books-wrapper",
                perRow: 1,
                itemAlign: 'left',
                resultHandler(item) {
                    return resultsHandler(item);
                },
                templates: {
                    item: getTemplate('search'),
                    empty: getTemplate('no-results')
                }
            })
        );

        /*
        Refinement List
         */
        this.refinementList(bookSearch, filtersClasses);

        // Start Book Search
        bookSearch.start();

        //Results Handler
        function resultsHandler(item) {
            item.templateVars = {};
            let contributorLinks = [];
            item.seoTitle = client.helpers.seoURL(item.title);

            if( item.title === "A Gay Guy's Guide to Life Love Food" ) {
                item.title = item.title.replace('Life Love', '<strike>Life Love</strike>');
            }

            //set Dates
            let isComingSoon = false;
            if( typeof item.publicationDate !== 'undefined' ) {
                let pubDate = item.publicationDate;
                let tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                tomorrow = toTimestamp(tomorrow);
                if( pubDate.toString().length === 13 ) {
                    pubDate = pubDate / 1000;
                }
                
                if( pubDate >= tomorrow ) {
                    isComingSoon = true;
                }
            }

            item.templateVars.isComingSoon = isComingSoon

            if( item.otherFormats && item.otherFormats.length > 0 ) {
                item.otherFormats.forEach((otherFormat) => {
                    otherFormat.title = item.seoTitle;
                });
            }

            if( item.contributorByLine && item.contributorByLine.length > 0 ) {
                item.contributorByLine = item.contributorByLine.split(',');
                item.contributorByLine.forEach((contributor) => {
                    contributorLinks.push(`<a class="sp__the-author" href="/author/${client.helpers.seoURL(contributor)}/">${contributor}</a>`)
                });
                item.templateVars.contributorLinks = contributorLinks.join(', ');
            }

            return item;
        }

        function statsHandler(item) {
            item.currentPage = item.currentPage + 1;
            let query = [];
            query.push(item.query);
            if( isbnsListParameterValue ) {
                query.push(isbnsListParameterValue);
            }
            if( categoryParameterValue ) {
                query.push(categoryParameterValue);
            }
            if( imprintParameterValue ) {
                query.push(imprintParameterValue);
            }
            if( publisherParameterValue ) {
                query.push(publisherParameterValue);
            }
            if( formatParameterValue ) {
                query.push(formatParameterValue);
            }
            if( fromDateParameterValue ) {
                query.push('from: ' + fromDateParameterValue);
            }
            if( toDateParameterValue ) {
                query.push('to: ' + toDateParameterValue);
            }
            item.query = query.join(', ');
            return item;
        }
    }

    refinementList(bookSearch, filtersClasses) {
        const filtersArray = {
            subject: 'hierarchicalCategories.lvl0',
            author: 'contributorByLine',
            imprint: 'imprint',
        };
        let i = 0;
        for( let filter in filtersArray ) {
            let collapsed = true;
            if( i === 0 ) {
                collapsed = false;
            }
            bookSearch.addWidget(
                bookSearch.widgets.refinementFilter({
                    container: `.search-results .${filter}`,
                    attribute: `${filtersArray[filter]}`,
                    sortBy: ['isRefined', 'name:asc'],
                    autoHide: true,
                    limit: 10,
                    showMore: true,
                    collapsible: {
                        collapsed: collapsed,
                    },
                    operator: 'or',
                    templates: {
                        header: `${filter}`,
                        item: getTemplate('facet')
                    },
                    classes: filtersClasses
                })
            );
            i++;
        }
    }

    async instantSearch() {
        this.run();

        //focus input to try new search if empty results
        if( document.querySelector('.search-results') !== null ) {
            document.querySelector('.search-results').addEventListener('click', (e) => {
                if( e.target.classList.contains('left-nav--top-link') ) {
                    e.target.parentElement.parentElement.classList.toggle('opened');
                }
                if( e.target.classList.contains('clear-all') ) {
                    window.history.replaceState(null, null, window.location.pathname);
                    this.run();
                    document.getElementById('search-field').focus();
                }
            });
        }
    }

}

export default InstantSearch;